import React from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useContext } from 'react';
import { ColorModeContext } from '../../App';
import { isShortPoolCctvPopupPath } from './cctvPopupRoutes';
import { useAuth } from '../../contexts/AuthContext';
import { isPoolSiteStandaloneView } from '../../utils/poolSitePaths';

/** CCTV 팝업 전용 화면에서는 테마 버튼 숨김 */
const ThemeModeToggleFab: React.FC = () => {
  const location = useLocation();
  const colorMode = useContext(ColorModeContext);
  const { authState } = useAuth();
  const isAdminLoggedIn = Boolean(
    authState.isAdminPasswordVerified && authState.isAuthenticated,
  );
  const siteStandalone = isPoolSiteStandaloneView(location.pathname, isAdminLoggedIn);

  const hide =
    siteStandalone ||
    isShortPoolCctvPopupPath(location.pathname) ||
    location.pathname === '/all/cctv' ||
    location.pathname.startsWith('/cctv-popup/');

  if (hide) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 9999,
        bgcolor: 'background.paper',
        boxShadow: 3,
        borderRadius: '50%',
      }}
    >
      <IconButton
        onClick={colorMode.toggleColorMode}
        color="inherit"
        aria-label={`Switch to ${colorMode.mode === 'light' ? 'dark' : 'light'} mode`}
      >
        {colorMode.mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Box>
  );
};

export default ThemeModeToggleFab;
